import Controller from '@ember/controller';
import { get } from '@ember/object';
import { empty } from '@ember/object/computed';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  fundsService: service(),
  router: service(),
  settings: service(),

  monthOptions: [
    {
      label: '',
      val: '',
    },
    {
      label: 'January',
      val: 1,
    },
    {
      label: 'February',
      val: 2,
    },
    {
      label: 'March',
      val: 3,
    },
    {
      label: 'April',
      val: 4,
    },
    {
      label: 'May',
      val: 5,
    },
    {
      label: 'June',
      val: 6,
    },
    {
      label: 'July',
      val: 7,
    },
    {
      label: 'August',
      val: 8,
    },
    {
      label: 'September',
      val: 9,
    },
    {
      label: 'October',
      val: 10,
    },
    {
      label: 'November',
      val: 11,
    },
    {
      label: 'December',
      val: 12,
    },
  ],

  defaultStartAtMonthEmpty: empty('model.defaultStartAtMonth'),

  save: task(function* () {
    let changeset = get(this, 'model.changeset');
    yield changeset.validate();
    if (get(changeset, 'isValid')) {
      yield this.fundsService.confirmValidFundToken();
      yield changeset.save();
      this.router.transitionTo('funds.fund.dashboard');
    }
  }).drop(),
});
